<template>
  <div>
    <div class="logo_box">
      <img :src="LOGO" />
    </div>
    <el-menu :default-active="activeMenu" :collapse="isCollapse" router unique-opened>
      <MenuList v-for="item in menuRouter" :key="item.path" :subMenu="item" />
    </el-menu>
  </div>
</template>

<script>
import MenuList from "./MenuList";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      menuRouter: [],
      LOGO: require('../../assets/images/logo.gif')
    };
  },
  components: {
    MenuList,
  },
  created() {
    this.allMenu();
  },
  computed: {
    activeMenu() {
      //动态菜单栏
      return this.$route.fullPath;
    },
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      routing: state => state.dynamicRouting
    }),
  },
  methods: {
    ...mapMutations(["changeMenuIsCollapse"]),
    // 获取菜单路由
    allMenu() {
      this.menuRouter = this.$router.options.routes[1].children;
      // this.amendRouter(this.routing)
      // this.menuRouter = this.routing[0].children
    },
    // 处理路由
    amendRouter(routes) {
      routes.forEach(item => {
        item.meta.menuShow = this.menuShow(item.meta.hideMenu)
        if (item.children) {
          this.amendRouter(item.children)
        }
      })
    },
    handleClick(e) {
      console.log(e, '这里面有什么')
    },
    menuShow(bool) {
      if (bool) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.switch {
  padding: 0 10px;
  cursor: pointer;
  i {
    width: 24px;
    text-align: center;
    font-size: 18px;
  }
}
.logo_box {
  height: 122px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 80px;
  }
}
.el-menu {
  border: none;
  .svg-icon {
    width: 24px;
    text-align: center;
    vertical-align: middle;
    margin-right: 6px;
  }
}
.el-menu--collapse {
  width: 40px !important;
  /deep/.el-submenu__icon-arrow {
    display: none;
  }
}
/deep/.el-tooltip {
  padding: 0 10px !important  ;
}
.el-menu-item {
  font-size: 16px;
  height: 34px;
  line-height: 34px;
  padding: 0 20px !important;
}
.fold-menu {
  height: 56px;
  line-height: 56px;
  padding: 0 10px !important;
}
.top-menu {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>
